var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 20",
    className: "icon__svg icon__svg--sky",
    fill: "currentColor",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 15.6s-.8.4-1.9.4c-1.2 0-1.9-.5-2.4-1.4l-3-5L18.3 5s.8-1 2.7-1c.8 0 1.3.1 1.3.1 1.3 2.1 3.1 5.4 3.9 6.4.2-.2 1.4-3.3 2.1-4.9 0 0 .5-1.6 2.3-1.6.9 0 1.5.2 1.5.2l-6.3 14.4s-.5 1.2-2.1 1.2c-1.2 0-1.5-.3-1.5-.3l2.6-5.7c-1.1-1.9-3.9-6.3-4.3-6.9-1.1 1.1-2 2-2.7 2.8l3.6 5.9zM10.8 2.1C10.8 1 11.6 0 13 0c.5 0 .9.1.9.1v14.2c0 1.3-.8 1.7-2.3 1.7-.4 0-.8-.1-.8-.1V2.1zM.3 15.1c0-2 1.1-2.1 2.1-2.1.9 0 2.3.2 2.9.2.9 0 1.4-.2 1.4-.9 0-.5-.7-.7-1.6-.8l-1.4-.3C2.6 11 1.6 10.7 1 10c-.3-.3-1-1-1-2.3 0-.7.1-1.8 1.4-2.8 1-.7 2.4-.9 4.5-.9 1.4 0 3.2.2 3.2.2s.1.4.1.8c0 1.2-.6 2-1.9 2-.9 0-2-.1-2.7-.1-.7-.1-1.6.1-1.6.7 0 .5.5.7 1.4.8 0 0 2 .3 2.9.6 1.1.3 2.5 1.3 2.5 3.3 0 1.2-.4 2.4-1.6 3.1-1.1.6-2.2.6-3.9.6-1.8 0-4-.3-4-.3v-.6z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3130c6da838ee5bee6d235463bc5774.svg";
export { ForwardRef as ReactComponent };